export const CLASS_NAME = {
  success: 'e-success',
  warning: 'e-warning',
  information: 'e-info',
  errors: 'e-error',
};

export const MESSAGE_TYPE = {
  warning: 'WARNING',
  success: 'SUCCESS',
  information: 'INFORMATION',
  errors: 'ERROR',
};

export const LOCAL_STORAGE_KEYS = {
  shellBaseUrlKey: `shell_base_url`,
  shellBaseUrlValue: `https://localhost:5002`,
};
export const CLAIMS_THRESHOLDS_VALUES = {
  showExportMessagesForTimeDurationInMilliSeconds: 3000,
  waitForExportToExcelMilliSeconds: 100,
};

export const CUSTOM_EVENT = {
  claimsShowHideExportModalDialog: `claims.show-export-to-excel-popup`,
};

export const SET_PRODUCTOR_SELECTOR_NAME_EVENT = 'setProductSelectorNameEvent';

export const CLAIMS_MICRO_UI = {
  claimAddSuccessMessage: 'Claim has been added successfully.',
  claimUpdateSuccessMessage: 'Claim has been updated successfully.',
  claimAddErrorMessage: 'An error occurred while adding the claim. Please try again.',
  claimEditErrorMessage: 'An error occurred while updating the claim. Please try again.',
  claimSystemErrorMessage: 'System error occurred while processing the claim.',
  claimsLoadingError: 'Error loading users. Please try again.',
  claimsNotFound: 'No results found',
  claimNotAvailable: 'No claims available',
  languageLoadingError: 'Error loading languages. Please try again.',
  companyMappingNotFound:
    'This account ID is not mapped to a Euromonitor company ID. Contact Data Quality team. Claim assertions cannot be added.',
  companyMappingFound: 'Mapped to company',
};

export const GENERIC_SEARCH_CONSTANTS = {
  DEFAULT_PLACEHOLDER: 'Type to search',
  DEFAULT_BIND_LABEL: 'name',
  DEFAULT_BIND_VALUE: 'id',
  DEFAULT_MIN_TERM_LENGTH: 1,
  BLUR_TIMEOUT_DELAY: 150,
  FOCUS_TIMEOUT_DELAY: 0,
  LOADING_MESSAGES: {
    LOADING_CLAIMS: 'Loading claims...',
    NO_CLAIMS_AVAILABLE: 'No claims available',
  },

  CSS_SELECTORS: {
    DROPDOWN_CONTAINER: '.dropdown-container',
    DROPDOWN_CONTENT: '.dropdown-content',
    SEARCH_DROPDOWN: '.search-dropdown',
    DROPDOWN_SEARCH: '.dropdown-search',
    LOADER: '.search-loader',
  },
};

export const ADD_EDIT_DIALOG_CONSTANTS = {
  DIALOG_TITLES: {
    ADD: 'Add New Claim',
    EDIT: 'Edit Claim',
    VIEW: 'View Claim Fields',
  },
  BUTTON_TEXTS: {
    ADD: 'Add Claim',
    UPDATE: 'Update Claim',
  },

  MODES: {
    ADD: 'add' as const,
    EDIT: 'edit' as const,
    VIEW: 'view' as const,
  },
};

export const ADD_VIEW_ASSERTION_DIALOG_CONSTANTS = {
  DIALOG_TITLES: {
    ADD: 'Add Assertion',
    VIEW: 'View Assertion',
  },
  MODES: {
    ADD: 'add' as const,
    VIEW: 'view' as const,
  },
};

export const MENU_ICONS = {
  ASSERTIONS_REGULAR: '<span class="fa-regular fa-clipboard-check"></span>',
  ASSERTIONS_SOLID: '<span class="fa-solid fa-clipboard-check"></span>',
  EXPORT: '<span class="fas fa-file-export"></span>',
};

export const UI_CONSTANTS = {
  DIALOG: {
    DEFAULT_WIDTH: '500px',
    PANEL_CLASS: 'add-edit-dialog-panel',
    MODAL_PANEL_CLASS: 'e-shares-prompt',
  },
  CSS_SELECTORS: {
    SNACK_BAR_CONTAINER: 'snack-bar-container',
  },
  PLACEHOLDERS: {
    CLIENT_NAME: 'Enter client name',
    ENTER_FOR_RESULT: 'Search',
    SELECT_OFFICE: 'Select office',
    SEARCH_OFFICE: 'Search office...',
    SELECT_CLAIM: 'Select a claim',
    DATE_FORMAT: 'DD/MM/YYYY',
    SEARCH_CLAIMS: 'Search claims...',
    CLAIM_FOOTNOTE: 'Enter claim footnote',
    CRM_ACCOUNT: 'Enter CRM account ID',
    CRM_LINK: 'Enter CRM link',
    CLAIM_WORDING: 'Enter claim details',
    LANGUAGE_TRANSLATION: 'Enter language codes',
    SELECT_LANGUAGE: 'Select language',
    SEARCH_LANGUAGE: 'Search language...',
  },

  TOOLTIPS: {
    OFFICE_CODE: 'Office Code',
    CLIENT: 'Client Name',
    SF_ACCOUNT: 'SF Account',
    OPPORTUNITY_OWNER: 'Opportunity Owner',
    CLAIM_RENEWAL: 'Claim Renewal',
    EXPIRY_DATE: 'Expiry Date',
    RESEARCH_USER: 'Research User',
    CLAIM_WORDING: 'Claim Wording',
    CLAIM_FOOTNOTE: 'Claim Footnote',
    COUNTER_SIGN_DATE: 'Counter Sign Date',
    CRM_LINK: 'CRM Link',
    LANGUAGE_TRANSLATION: 'Language Translation',
  },
};

export const OFFICE_CODE_OPTIONS = [
  { id: 1, code: 'L', label: 'London' },
  { id: 2, code: 'B', label: 'Bangalore' },
  { id: 3, code: 'N', label: 'New York' },
  { id: 4, code: 'S', label: 'Singapore' },
  { id: 5, code: 'T', label: 'Toronto' },
  { id: 6, code: 'Y', label: 'Sydney' },
  { id: 7, code: 'J', label: 'Tokyo' },
  { id: 8, code: 'M', label: 'Mumbai' },
];

export const SOURCE_TYPE_ID = 2;

export const CRM_LINK_TEMPLATE = (id: string) =>
  `<a class="crm-link" data-id="${id}" style="cursor:pointer;"> ${id} </a>`;

export const DIALOG_CONFIGURATIONS = {
  DELETE_CLAIM: {
    disableClose: true,
    data: {
      title: 'You are about to delete a claim!',
      proceedText: 'Proceed',
      proceedDescription: 'Delete the claim. You will not be able to undo this change.',
      cancelText: 'Cancel',
      cancelDescription: 'Close without making any changes.',
    },
  },
} as const;

export const DIALOG_CONFIGURATIONS_ASSERTION = {
  DELETE_CLAIM_ASSERTION: {
    disableClose: true,
    data: {
      title: 'You are about to delete a claim assertion!',
      proceedText: 'Proceed',
      proceedDescription: 'Delete the claim. You will not be able to undo this change.',
      cancelText: 'Cancel',
      cancelDescription: 'Close without making any changes.',
    },
  },
} as const;

export const CLAIMS_GRID_COLUMN_DEFS_BASE = [
  {
    headerCheckboxSelection: true,
    checkboxSelection: true,
    width: 50,
    pinned: 'left',
    suppressNavigable: true,
    filter: false,
    suppressMenu: true,
  },
  {
    field: 'client',
    sortable: true,
    resizable: true,
    filter: false,
    suppressMenu: true,
  },
  {
    headerName: 'CRM Account',
    field: 'sfAccount',
    sortable: true,
    resizable: true,
    filter: false,
    suppressMenu: true,
  },
  {
    field: 'oppurtunityOwner',
    sortable: true,
    resizable: true,
    filter: false,
    suppressMenu: true,
  },
  {
    field: 'office',
    sortable: true,
    resizable: true,
    filter: false,
    suppressMenu: true,
  },
  {
    headerName: 'View',
    field: '',
    width: 70,
    cellClass: 'e-view-icon-cell',
    filter: false,
    suppressMenu: true,
  },
  {
    field: 'expiryDate',
    sortable: true,
    resizable: true,
    filter: false,
    suppressMenu: true,
  },
  {
    headerName: 'Wording',
    field: 'wording',
    sortable: true,
    width: 300,
    autoHeight: true,
    resizable: true,
    wrapText: true,
    cellClass: 'cell-wrap-text',
    filter: false,
    suppressMenu: true,
  },
];

export const ASSERTIONS_GRID_COLUMN_DEFS = [
  {
    headerName: 'Geography',
    field: 'geographyName',
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 175,
  },
  {
    headerName: 'Category',
    field: 'categoryName',
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 318,
  },
  {
    headerName: 'Brand',
    field: 'brandName',
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 240,
  },
  {
    headerName: 'Company',
    field: 'companyName',
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 220,
  },
  {
    headerName: 'Rank',
    field: 'rank',
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 90,
    cellStyle: { textAlign: 'center' },
  },
  {
    headerName: 'Action',
    field: 'action',
    minWidth: 95,
    resizable: false,
    cellStyle: { textAlign: 'center' },
    cellRenderer: (params: any) => {
      if (!params.data) return '';
      const id = params.data.assertionId || params.data.id;
      return `
        <div style="display: flex; gap: 8px; justify-content: center; align-items: center; height: 100%;">
          <span attr.aria-label="View assertion" role="button" class="fad fa-solid fa-user-magnifying-glass" 
                data-action="view" data-id="${id}" 
                style="cursor: pointer; color: #0066cc; font-size: 16px;"
                title="View Assertion">
          </span>
          <span attr.aria-label="Delete assertion" role="button" class="fas fa-trash action-btn delete-btn" 
                data-action="delete" data-id="${id}"
                style="cursor: pointer; color: #0066cc; font-size: 16px;"
                title="Delete Assertion">
          </span>
        </div>
      `;
    },
  },
];
export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const DELETE_CLAIM_DIALOG_CONFIG = DIALOG_CONFIGURATIONS.DELETE_CLAIM;

export const ASSERTIONS_MICRO_UI = {
  assertionAddSuccessMessage: 'Assertion has been added successfully.',
  assertionAddErrorMessage: 'An unexpected error occurred. Please contact support.',
  assertionMissingClaim: 'Missing claim ID. Cannot create assertion.',
  duplicateAssertionErrorMessage: 'Cannot insert duplicate key in object \'dbo.ClaimAssertion\'',
  geographyError:'You have selected a geography that is not in MRD. Please try again with a different selection.',
  categoryError: 'You have selected a category that is not in MRD. Please try again with a different selection.',
  companyShareTypes: ['NBO', 'GBO'],
  brandShareTypes: ['LBN', 'UBN', 'GBN'],
  shareTypeError: 'This project does not have any shares. You can not record a syndicated claim on this industry.',
}

// claims-ui-tab-order.constants.ts

export const TAB_ORDER: Array<[string | null, string]> = [
  ['projectCode', 'ng-select[formcontrolname="projectCode"] .ng-select-container'],
  ['claimShareType', 'mat-select[formcontrolname="claimShareType"]'],
  ['geography', 'mat-select[formcontrolname="geography"]'],
  ['product', 'mat-select[formcontrolname="product"]'],
  ['company', 'input[formcontrolname="company"]'],
  ['brand', 'input[formcontrolname="brand"]'],
  ['dataType', 'ng-select[formcontrolname="dataType"] .ng-select-container'],
  ['companyType', 'mat-select[formcontrolname="companyType"]'],
  ['claimCalculation', 'mat-select[formcontrolname="claimCalculation"]'],
  ['claimRank', 'input[formcontrolname="claimRank"]'],
  ['claimYear', 'mat-select[formcontrolname="claimYear"]'],
  ['notes', 'textarea[formcontrolname="notes"]'],
  [null, 'button.e-cancel-dialog-button'],
  [null, 'button.e-dialog-button:not(.e-cancel-dialog-button)'],
];

export const CLAIMS_TAB_ORDER: Array<[string | null, string]> = [
  ['client', 'input[formcontrolname="client"]'],
  ['opportunityOwnerEmail', 'emma-generic-search[formcontrolname="opportunityOwnerEmail"]'],
  ['claimRenewalId', 'emma-generic-search[formcontrolname="claimRenewalId"]'],
  ['mainResearchUserId', 'emma-generic-search[formcontrolname="mainResearchUserId"]'],
  ['claimFootnote', 'input[formcontrolname="claimFootnote"]'],
  ['crmLink', 'input[formcontrolname="crmLink"]'],
  ['sfAccountId', 'input[formcontrolname="sfAccountId"]'],
  ['officeCodeDisplay', 'emma-generic-search[formcontrolname="officeCodeDisplay"]'],
  ['expiryDate', 'input[formcontrolname="expiryDate"]'],
  ['claimWording', 'input[formcontrolname="claimWording"]'],
  ['counterSignDate', 'input[formcontrolname="counterSignDate"]'],
  ['languageTranslation', 'emma-generic-search[formcontrolname="languageTranslation"]'],
  [null, 'button.e-cancel-dialog-button'],
  [null, 'button.e-accept-dialog-button'],
];

export type ModalType = 'assertions' | 'claims';
